const get_robot_icon = (robot) => {
  return robot.type == "gocart"
    ? "images/gocart.png"
    : robot.type == "spot"
    ? "images/spot.jpg"
    : robot.type == "syscon"
    ? "images/syscon.png"
    : robot.type == "tracer"
    ? "images/tracer.png"
    : robot.type == "demobot2"
    ? "images/demobot2.png"
    : "images/unknown_robot_type.png";
};

const hasCamera = (robot) => {
  const settings = robot?.setting || {};
  if (!settings?.cameras) return false;
  const cameras = settings?.cameras || [];
  for (let index = 0; index < cameras.length; index++) {
    const camera = cameras[index];
    if (camera?.class_name != "DummyCamera") {
      return true;
    }
  }
  return false;
};

const hasSpeaker = (robot) => {
  const settings = robot?.setting || {};
  if (!settings?.speakers) return false;
  const speakers = settings?.speakers || [];
  return speakers.length > 0;
};

const hasMicrophones = (robot) => {
  const settings = robot?.setting || {};
  if (!settings?.microphones) return false;
  const microphones = settings?.microphones || [];
  return microphones.length > 0;
};

const group_robot_connections = (robots) => {
  const robotGroups = {};

  for (let index = 0; index < robots.length; index++) {
    const robot_info = robots[index];
    const settings = robot_info?.setting || {};
    const is_control_channel = settings?.is_control_channel || false;
    const has_camera = hasCamera(robot_info);
    const has_speaker = hasSpeaker(robot_info);
    const has_microphones = hasMicrophones(robot_info);

    const robot = {
      ...robot_info,
      has_camera: has_camera,
      has_speaker: has_speaker,
      has_microphones: has_microphones,
    };

    const group_id = robot?.robot_id != null ? robot.robot_id : "";
    
    const connecting_user_clients = robot?.connecting_user_clients
      ? Object.entries(robot.connecting_user_clients)
      : [];

    if (robotGroups[group_id]) {
      robotGroups[group_id] = {
        ...robotGroups[group_id],
        connections: [...robotGroups[group_id].connections, robot],
        status:
          robot.status === "online" ? "online" : robotGroups[group_id].status,
        control_connections:
          is_control_channel == false
            ? [...robotGroups[group_id].control_connections]
            : [...robotGroups[group_id].control_connections, robot.id],
        connecting_user_clients: [
          ...robotGroups[group_id].connecting_user_clients,
          ...connecting_user_clients,
        ],
      };
    } else {
      robotGroups[group_id] = {
        group_id: group_id,
        ...robot,
        icon: get_robot_icon(robot),
        robot_id: group_id,
        connections: [robot],
        status: robot.status,
        control_connections: is_control_channel == false ? [] : [robot.id],
        connecting_user_clients: connecting_user_clients,
      };
    }
  }
  // console.log("robotGroups", robotGroups);
  return robotGroups;
};

export const userDataReducer = (state, action) => {
  switch (action.type) {
    case "SET_ROBOTLIST": {
      const robots = [...action.payload];
      const robotGroups = group_robot_connections(robots);

      return {
        ...state,
        robotList: robots,
        robotGroups,
      };
    }

    case "SET_USER_ROBOTS_DATA": {
      const { page, per_page, total, results } = action?.payload || {
        page: 1,
        per_page: 5,
        total: 0,
        results: [],
      };
      return {
        ...state,
        robotsData: { page, per_page, total, results },
      };
    }

    case "SET_USER_ORGS_DATA": {
      const { page, per_page, total, results } = action?.payload || {
        page: 1,
        per_page: 5,
        total: 0,
        results: [],
      };
      return {
        ...state,
        orgsData: { page, per_page, total, results },
      };
    }

    case "SET_ROBOT_CONNECTED": {
      const robot_id = action.payload.id;

      const updatedRobotList = state.robotList.map((rb) =>
        rb.id === robot_id ? { ...rb, ...action.payload } : rb
      );

      const updatedRobotGroupList = group_robot_connections(updatedRobotList);

      return {
        ...state,
        robotList: updatedRobotList,
        robotGroups: updatedRobotGroupList,
      };
    }

    case "SET_ROBOT_DISCONNECTED": {
      const robot_id = action.payload.id;

      const updatedRobotList = state.robotList.map((rb) =>
        rb.id === robot_id
          ? { ...rb, ...action.payload, status: "offline" }
          : rb
      );

      const updatedRobotGroupList = group_robot_connections(updatedRobotList);

      return {
        ...state,
        robotList: updatedRobotList,
        robotGroups: updatedRobotGroupList,
      };
    }
    case "UPDATE_ROBOT_CLIENT_DATA": {
      const { robot_client_id, updated_data } = action.payload;
      const updatedRobotList = state.robotList.map((rb) =>
        rb.id === robot_client_id ? { ...rb, ...updated_data } : rb
      );

      const updatedRobotGroupList = group_robot_connections(updatedRobotList);

      return {
        ...state,
        robotList: updatedRobotList,
        robotGroups: updatedRobotGroupList,
      };
    }

    default:
      return state;
  }
};

export const initialUserData = {
  robotList: [],
  robotGroups: {},
  robotsData: {
    page: 1,
    per_page: 10,
    total: 0,
    results: [],
  },
  orgsData: {
    page: 1,
    per_page: 10,
    total: 0,
    results: [],
  },
};
